import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';

import App from './App.tsx';
import { LangProvider } from './provider/LangProvider.tsx';
import { SettingsProvider } from './provider/SettingsProvider.tsx';
import { NotistackProvider } from './provider/SnakbarProvider.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SettingsProvider>
      <LangProvider>
        <NotistackProvider />
        <App />
      </LangProvider>
    </SettingsProvider>
  </StrictMode>
);
